export default __webpack_public_path__ + "static/media/img-icon.cc6c357a.svg";